module.exports = __webpack_public_path__ + "static/media/original(1).eb3458eb.webp";